<div [@fadeIn]="state">
    <ng-container *ngIf="analytics">
        <div class="analytics-description__data-piece-label ms-fcl-np">{{ generalInfo }}</div>
        <div class="analytics-description__data-piece-label ms-fcl-np">{{ detailedViewInfo }}</div>
    </ng-container>
</div>
